export const getUserName = (firstName?: string, lastName?: string) => {
  return `${firstName ? firstName : ''}${firstName && lastName ? ' ' : ''}${lastName ? lastName : ''}`
}

export const getInitials = (name?: string) => {
  try {
    if (!name) {
      return ''
    }

    const parts = name.trim().split(/\s+/)

    if (parts.length === 1) {
      return parts[0][0].toUpperCase()
    }

    return (parts[0][0] + parts[1][0]).toUpperCase()
  } catch {
    return ''
  }
}
